var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWolf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "233px",
    height: "373px",
    viewBox: "-0.5 -0.5 233 373",
    content: "<mxfile modified=\"2019-03-24T13:05:30.893Z\" host=\"www.draw.io\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_14_2) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/73.0.3683.86 Safari/537.36\" etag=\"zz6O0YJvv9izZHhqS9xk\" version=\"10.5.4\" type=\"device\"><diagram id=\"n2zo3Feh87eFmzQer1Gg\" name=\"Page-1\">7ZpLj5swEIB/TY6RsA0Bjk26u23Vlaqu1J7d4AItwZHjvPrr6xQTYNAKijBR5L0gM5ixPd+MHwMzstqcngTdJs88YtkMO9FpRt7PMPa9QF0vgnMhmBPfLSSxSKNChirBS/qHaaGjpfs0YrtGRcl5JtNtU7jmec7WsiGjQvBjs9pPnjVb3dKYtQQva5q1pd/TSCZaihZh9eADS+NENx1gv3iwoWVlPZJdQiN+rInIw4ysBOeyKG1OK5ZdjFfapXjv8ZWn144Jlss+L4gfzudvn756y+f5x+3hV/ZEHoO51nKg2V4PWHdWnksLsDx6dzGkust5roTLRG4ydYdUcScF/321jBrTsnifRS2zVv1E19Ert2F8w6Q4qyrHyr6etllSs2wpEyyjMj001VONOb6qu7bwhaeqYexolySO1qM9Miw9rVSx43uxZvqtuj2hIgIUeUCRpCJmsqVIFWrDrkT/cP0HOvyGbjA6qGjRD50yJj3Xqm0vFXavdxiHoB3SCFFVKDSO6hfEOr/AATCzO7FfjIXOfUMHJ9G+6Fqh5k+LzrMOXef61zvqvNtG3cI+dD6weHCn6Hzr0I03YXYtmobRBdahg7sL5Dh3utiF9rEba8Z04RZzYnTlkckmdjBawqGrXQgDGB5ATcOzMF2Doc3xUHqd069petg+ep0R03vedKEmOAObpmdfXsVDwOZ46IbFhX6AJ06WIvtSK3CngfDgPcvN6VmYXYHrHhoae90rqGl6FiZYxtpy3vy4YF+GZcTIg3sWNHGOBVmYZOm0+WB6mExMz8I0C4w9fLf0sH1n9e4zWl96Hty7IkNf6F0fNtT8i8bMJ/rSFSzyjW6ivX2j81RqOrLtywSMd5aEny7aM7xpehaeJRdjraoG6anb6l/Ionr1Ryl5+As=</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 21 1 L 51 41",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21 1 L 15.47 12.06 Q 11 21 14.16 30.49 L 21 51",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 31 L 21 51",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 41 L 11 61",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 51 41 L 71 51",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 91 71 L 71 51",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 41 L 1 31",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21 91 L 11 61",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 91 71 L 121 61",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 81 L 111 101",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41 111 L 21 91",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 101 L 161 171",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 231 291 L 211 341",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 121 371 L 211 341",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41 191 L 41 111",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 111 81 L 121 61",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41 191 L 61 231",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 61 231 L 61 321",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 41 331 L 61 321",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 161 171 L 185 203 Q 191 211 197 219 L 221 251",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 221 251 L 231 291",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 121 371 L 11 331",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 81 331 L 11 331",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    pointerEvents: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWolf);
export default __webpack_public_path__ + "static/media/wolf.fffabd28a35fedc62ab4052b83dd628f.svg";
export { ForwardRef as ReactComponent };